// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"mF-z"};